export const countryIsoCodesWithVat = ['US', 'NO'];
